import React from "react";
import "../../styles/holidays/specialButton.scss";

export function SpecialButton({ className = "", ...props }) {
    return <button {...props} className={`special_btn ${className}`} />;
}
